const sign_up_and_sign_in = {
    identifiers_email: 'ที่อยู่อีเมล',
    identifiers_phone: 'หมายเลขโทรศัพท์',
    identifiers_username: 'ชื่อผู้ใช้',
    identifiers_email_or_sms: 'ที่อยู่อีเมลหรือหมายเลขโทรศัพท์',
    identifiers_none: 'ไม่มี',
    and: 'และ',
    or: 'หรือ',
    sign_up: {
        title: 'สมัครสมาชิก',
        sign_up_identifier: 'ตัวระบุการสมัครสมาชิก',
        identifier_description: 'ตัวระบุที่เลือกสำหรับการสมัครสมาชิกทั้งหมดต้องกรอกขณะสร้างบัญชีใหม่',
        sign_up_authentication: 'การตั้งค่าการยืนยันตัวตนสำหรับการสมัครสมาชิก',
        verification_tip: 'ผู้ใช้ต้องยืนยันอีเมลหรือหมายเลขโทรศัพท์ที่คุณตั้งค่าไว้ด้วยการกรอกรหัสยืนยันระหว่างสมัครสมาชิก',
        authentication_description: 'การดำเนินการที่เลือกทั้งหมดจะเป็นข้อบังคับสำหรับผู้ใช้ในการดำเนินขั้นตอนให้เสร็จสมบูรณ์',
        set_a_password_option: 'สร้างรหัสผ่านของคุณ',
        verify_at_sign_up_option: 'ยืนยันตัวตนในขั้นตอนสมัครสมาชิก',
        social_only_creation_description: '(ใช้สำหรับการสร้างบัญชีด้วยโซเชียลเท่านั้น)',
        collect_user_profile: 'เก็บข้อมูลโปรไฟล์ผู้ใช้',
        add_profile_fields: 'เพิ่มฟิลด์โปรไฟล์',
        profile_fields_hint: {
            not_in_list: 'ไม่มีในรายการ?',
            set_up: 'ตั้งค่า',
            go_to: 'ฟิลด์โปรไฟล์อื่นตอนนี้',
        },
    },
    sign_in: {
        title: 'เข้าสู่ระบบ',
        sign_in_identifier_and_auth: 'การตั้งค่าตัวระบุและการยืนยันตัวตนสำหรับการเข้าสู่ระบบ',
        description: 'ผู้ใช้สามารถเข้าสู่ระบบด้วยตัวเลือกที่มีอยู่',
        add_sign_in_method: 'เพิ่มวิธีเข้าสู่ระบบ',
        add_sign_up_method: 'เพิ่มวิธีสมัครสมาชิก',
        password_auth: 'รหัสผ่าน',
        verification_code_auth: 'รหัสยืนยัน',
        auth_swap_tip: 'สลับตัวเลือกด้านล่างเพื่อตัดสินใจว่าจะให้ตัวเลือกใดแสดงก่อนในกระบวนการ',
        require_auth_factor: 'คุณต้องเลือกปัจจัยการยืนยันตัวตนอย่างน้อยหนึ่งรายการ',
        forgot_password: 'ลืมรหัสผ่าน',
        forgot_password_description: 'ผู้ใช้สามารถรีเซ็ตรหัสผ่านได้โดยใช้วิธีการยืนยันใดก็ได้ที่มี',
        add_verification_method: 'เพิ่มวิธีการยืนยันตัวตน',
        email_verification_code: 'รหัสยืนยันอีเมล',
        phone_verification_code: 'รหัสยืนยันโทรศัพท์',
    },
    social_sign_in: {
        title: 'เข้าสู่ระบบผ่านโซเชียล',
        social_sign_in: 'เข้าสู่ระบบด้วยโซเชียล',
        description: 'ขึ้นอยู่กับตัวระบุที่คุณกำหนด ผู้ใช้อาจต้องระบุตัวตนเมื่อสมัครผ่านตัวเชื่อมต่อโซเชียล',
        add_social_connector: 'เพิ่มตัวเชื่อมต่อโซเชียล',
        set_up_hint: {
            not_in_list: 'ไม่มีในรายการ?',
            set_up_more: 'ตั้งค่า',
            go_to: 'ตัวเชื่อมต่อโซเชียลอื่น ๆ ตอนนี้',
        },
        settings_title: 'ประสบการณ์การใช้งานการเข้าสู่ระบบผ่านโซเชียล',
        automatic_account_linking: 'เชื่อมโยงบัญชีที่มีตัวระบุเดียวกันโดยอัตโนมัติ',
        automatic_account_linking_tip: 'เมื่อเปิดใช้งาน ถ้าผู้ใช้เข้าสู่ระบบด้วยตัวตนโซเชียลใหม่และมีบัญชีที่มีตัวระบุเดียวกัน (เช่น ที่อยู่อีเมล) JX Account จะเชื่อมโยงตัวตนโซเชียลกับบัญชีนั้นโดยอัตโนมัติ ผู้ใช้จะไม่ถูกถามว่าต้องการเชื่อมบัญชีหรือไม่',
        required_sign_up_identifiers: 'บังคับให้ผู้ใช้กรอกข้อมูลการสมัครที่ขาดหาย',
        required_sign_up_identifiers_tip: 'เมื่อเปิดใช้งาน ผู้ใช้ที่เข้าสู่ระบบผ่านผู้ให้บริการโซเชียลต้องกรอกข้อมูลการสมัครที่ขาดหาย (เช่น อีเมล) ก่อนทำการเข้าสู่ระบบ \n\nถ้าปิด ผู้ใช้สามารถดำเนินการต่อโดยไม่ต้องกรอกตัวระบุที่ขาดหาย แม้ว่าบัญชีโซเชียลจะไม่ได้ซิงค์ข้อมูลดังกล่าว',
    },
    passkey_sign_in: {
        title: 'เข้าสู่ระบบด้วย PASSKEY',
        passkey_sign_in: 'เข้าสู่ระบบด้วย Passkey',
        enable_passkey_sign_in_description: 'อนุญาตให้ผู้ใช้เข้าถึงแอปพลิเคชันอย่างรวดเร็วและปลอดภัยผ่าน Passkey (WebAuthn) โดยใช้ไบโอเมตริกซ์หรือคีย์ความปลอดภัย เป็นต้น',
        prompts: 'พรอมต์ Passkey',
        show_passkey_button: 'แสดงปุ่ม "ดำเนินการต่อด้วย Passkey" บนหน้าเข้าสู่ระบบ',
        show_passkey_button_tip: 'การปิดปุ่ม "ดำเนินการต่อด้วย Passkey" ทำให้การเข้าสู่ระบบเป็นแบบระบุตัวตนก่อน โดยแสดงตัวเลือกรหัสผ่านและ Passkey ในขั้นตอนถัดไป',
        allow_autofill: 'อนุญาตให้แจ้งเตือนและกรอก Passkey ที่ลงทะเบียนไว้ในช่องระบุตัวตนโดยอัตโนมัติ',
    },
    tip: {
        set_a_password: 'จำเป็นต้องตั้งรหัสผ่านสำหรับชื่อผู้ใช้ของคุณ',
        verify_at_sign_up: 'ขณะนี้เรารองรับเฉพาะการยืนยันอีเมลและโทรศัพท์เท่านั้น ผู้ใช้อาจให้ที่อยู่อีเมลหรือเบอร์โทรที่ไม่ถูกต้องหากไม่มีการยืนยัน',
        password_auth: 'จำเป็นมากหากคุณเปิดใช้งานตัวเลือกการตั้งรหัสผ่านระหว่างสมัครสมาชิก',
        verification_code_auth: 'จำเป็นมากหากคุณเปิดแค่ตัวเลือกการกรอกรหัสยืนยันในขั้นตอนสมัครสมาชิก คุณสามารถไม่ติ๊กช่องนี้ได้เมื่ออนุญาตให้ตั้งรหัสผ่านในขั้นตอนสมัครสมาชิก',
        email_mfa_enabled: 'รหัสยืนยันอีเมลถูกเปิดใช้งานแล้วสำหรับ MFA และจะไม่สามารถใช้เป็นวิธีการเข้าสู่ระบบหลักได้เพื่อความปลอดภัย',
        phone_mfa_enabled: 'รหัสยืนยันโทรศัพท์ถูกเปิดใช้งานแล้วสำหรับ MFA และจะไม่สามารถใช้เป็นวิธีการเข้าสู่ระบบหลักได้เพื่อความปลอดภัย',
        delete_sign_in_method: 'จำเป็น เนื่องจากคุณเลือก {{identifier}} ให้เป็นตัวระบุที่ต้องใช้',
        password_disabled_notification: 'ตัวเลือก "สร้างรหัสผ่านของคุณ" ถูกปิดใช้งานในขั้นตอนสมัครสมาชิกด้วยชื่อผู้ใช้ ซึ่งอาจทำให้ผู้ใช้เข้าสู่ระบบไม่ได้ กรุณายืนยันหากต้องการบันทึก',
    },
    advanced_options: {
        title: 'ตัวเลือกขั้นสูง',
        enable_single_sign_on: 'เปิดใช้งาน Single Sign-On (SSO) สำหรับองค์กร',
        enable_single_sign_on_description: 'อนุญาตให้ผู้ใช้เข้าสู่ระบบแอปพลิเคชันด้วย Single Sign-On โดยใช้บัญชีองค์กรของพวกเขา',
        single_sign_on_hint: {
            prefix: 'ไปที่ ',
            link: '"Enterprise SSO"',
            suffix: ' เพื่อดูตัวเชื่อมต่อองค์กรเพิ่มเติม',
        },
        enable_user_registration: 'เปิดใช้งานการลงทะเบียนผู้ใช้',
        enable_user_registration_description: 'เปิดหรือปิดให้มีการลงทะเบียนผู้ใช้ เมื่อปิด ผู้ดูแลระบบยังสามารถเพิ่มผู้ใช้ผ่านแผงควบคุมได้ แต่ผู้ใช้จะไม่สามารถสร้างบัญชีใหม่ผ่านหน้าล็อกอินได้อีก',
        unknown_session_redirect_url: 'URL สำหรับเปลี่ยนเส้นทางเมื่อเซสชันไม่รู้จัก',
        unknown_session_redirect_url_tip: 'บางครั้ง JX Account อาจไม่รู้จักเซสชันของผู้ใช้บนหน้าล็อกอิน เช่น กรณีเซสชันหมดอายุหรือผู้ใช้บุ๊กมาร์ก/แชร์ลิงก์เข้าสู่ระบบ ปกติจะขึ้นข้อผิดพลาด “unknown session” 404 เพื่อปรับประสบการณ์ผู้ใช้ ให้ตั้งค่า URL สำรองเพื่อเปลี่ยนเส้นทางผู้ใช้กลับไปยังแอปและเริ่มยืนยันตัวตนใหม่',
    },
    username_policy: {
        title: 'นโยบายชื่อผู้ใช้',
        description: 'ปรับแต่งข้อกำหนดของชื่อผู้ใช้ รวมถึงความยาว อักขระที่อนุญาต และการแยกแยะตัวพิมพ์ใหญ่-เล็ก',
        manage_button: 'จัดการ',
        modal_title: 'นโยบายชื่อผู้ใช้',
        modal_description: 'ปรับแต่งข้อกำหนดของชื่อผู้ใช้สำหรับผู้ใช้ปลายทางของคุณ',
        length: {
            title: 'ความยาวของชื่อผู้ใช้',
            minimum: 'ต่ำสุด',
            maximum: 'สูงสุด',
            min_greater_than_max: 'ความยาวต่ำสุดต้องไม่มากกว่าความยาวสูงสุด',
        },
        allowed_chars: {
            title: 'ประเภทอักขระที่อนุญาต',
            uppercase: 'ตัวพิมพ์ใหญ่ (A-Z)',
            lowercase: 'ตัวพิมพ์เล็ก (a-z)',
            numbers: 'ตัวเลข (0-9)',
            underscore: 'ขีดล่าง (_)',
            no_valid_leading_char: 'ไม่อนุญาตให้ใช้ตัวเลขเพียงอย่างเดียว โปรดเปิดใช้งานอย่างน้อยหนึ่งอย่างจากตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก หรือขีดล่าง',
            no_char_selected: 'เลือกประเภทอักขระอย่างน้อยหนึ่งประเภท',
        },
        case_sensitive: {
            title: 'ชื่อผู้ใช้ที่แยกแยะตัวพิมพ์ใหญ่-เล็ก',
            description: 'ถือว่าตัวพิมพ์ใหญ่และตัวพิมพ์เล็กเป็นคนละตัว ‘user123’ และ ‘User123’ จะถือเป็นชื่อผู้ใช้ที่แตกต่างกัน',
        },
        case_conflicts: {
            title: 'ตรวจพบความขัดแย้งของชื่อผู้ใช้ที่มีอยู่',
            description: 'ชื่อผู้ใช้บางชื่อจะขัดแย้งกันหากปิดการแยกแยะตัวพิมพ์ใหญ่-เล็ก โปรดแก้ไขกลุ่มที่ขัดแย้งกัน {{count}} กลุ่มด้านล่างก่อนบันทึก',
            sample_title: 'ชื่อผู้ใช้ที่ขัดแย้งกัน',
        },
    },
};
export default Object.freeze(sign_up_and_sign_in);
